/* import __COLOCATED_TEMPLATE__ from './legal.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { ProductName } from '@banking/ui/models/checking/product-positioning';
import { inject as service } from '@ember/service';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
import { htmlSafe } from '@ember/template';
let Legal = (_class = class Legal extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "features", _descriptor3, this);
    _initializerDefineProperty(this, "savingsApy", _descriptor4, this);
    _initializerDefineProperty(this, "storedBalanceProductPositioning", _descriptor5, this);
  }
  get canAccessSfsSavings() {
    return this.features.isEnabled('banking/access_sfs_savings');
  }
  get legalDisclosures() {
    const disclosures = [];
    // NOTE(steckel): Legal should not be tied to product-positioning, though
    // it does have a relationship.
    // We'll need a new abstraction for this in the future.
    if (this.storedBalanceProductPositioning.productName === ProductName.CheckingAndDebit) {
      disclosures.push(this.intl.t('banking.launchpad.legal.storedBalance.checkingAndDebit'));
    }
    if (this.canAccessSfsSavings) {
      disclosures.push(this.intl.t('banking.launchpad.legal.savings', {
        apy: this.savingsApy.rate,
        date: this.savingsApy.changeDate
      }));
    }
    // Only show this footer if there is a loan offer and the user is from the US, according
    // to Legal in https://jira.sqprod.co/browse/CINTL-1304.
    if (this.args.hasLoanOffer && Country[this.userInfo.countryCode] === Country.US) {
      disclosures.push(this.intl.t('banking.launchpad.legal.loans'));
    }
    return htmlSafe(disclosures.join('</br></br>'));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "savingsApy", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "storedBalanceProductPositioning", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Legal as default };